import React, { useEffect, useState } from "react";
import MainContainer from "../../components/app/maincontainer";
import Header from "../../components/partials/header";
import RequestTable from "../../components/tables/request-table";
import { AddUsersModal } from "../../components/modals/addtoolsmodal";
import { useNavigate } from "react-router-dom";
import { useRequestStore } from "../../data/stores/loggerStore";
import { apiCall } from "../../data/useFetcher";
import RawSample from "../../assets/Tool Bulk Upload Sample.xlsx";
import { toast } from "react-toastify";
import useErrorStore from "../../data/stores/errorStore";
import DoneModal from "../../components/modals/donemodal";

const NewRequest = () => {
	let { getLogger, getDynamicLogger }: any = useRequestStore();
	const [modal, setModal] = useState("");
	const tabs = [
			{ title: "all requests", statusText: "all" },
			{ title: "Pending requests", statusText: "pending" },
			{ title: "completed requests", statusText: "completed" },
			{ title: "invites", statusText: "invited" },
		],
		[tab, setTab] = useState(tabs?.[0]?.statusText),
		navigate = useNavigate();

	const toggleUploadModal = () => {
		setModal("");
	};

	useEffect(() => {
		apiCall({
			type: "get",
			url: `/api/v1/tools/new-request${
				tab !== "all" ? `?statusText=${tab}` : ""
			}`,
			getter: (d: any) =>
				tab !== "all" ? getDynamicLogger(d, tab) : getLogger(d),
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [tab]);

	let [loading, setLoading] = useState(null),
		{ returnErrors } = useErrorStore();
	const onSubmit = async (data: any[]) => {
		if (!data || data?.length === 0)
			return toast.info("Tools' details required");
		setLoading(true);

		let { response, errArr, errMsg } = await apiCall({
			type: "put",
			url: `/api/v1/tools/manage-tools`,
			data: {
				tools: data,
			},
		});
		// console.log({ response, errArr, errMsg });
		if (errArr) {
			setLoading(false);
			return returnErrors(errArr);
		}
		if (errMsg) {
			setLoading(false);
			return toast.error(errMsg);
		}
		setLoading(false);
		if (response) {
			apiCall({
				type: "get",
				url: `/api/v1/tools/new-request${
					tab !== "all" ? `?statusText=${tab}` : ""
				}`,
				getter: (d: any) =>
					tab !== "all" ? getDynamicLogger(d, tab) : getLogger(d),
			});
			setModal("done");
			return;
		}
		setLoading(false);
	};

	return (
		<div>
			<MainContainer>
				<Header
					btn2Text={"Send Invite"}
					btn1Text={""}
					handleAdd={() => navigate("add-request")}
					handleModal={null}
					text="Requests"
				/>
				<div className="mt-8 bg-white rounded-lg p-6">
					<div className="h-16 border-b border-b-[#E3E3E3] flex gap-4">
						{tabs?.map(t => (
							<button
								onClick={() => setTab(t?.statusText)}
								className={`h-full capitalize px-1 text-base ${
									tab === t?.statusText
										? "font-medium border-b-4 text-[#111014] border-b-[#2658AB]"
										: "font-normal border-b-none text-[#878789]"
								}`}>
								{t?.title}
							</button>
						))}
					</div>
					<div className="mt-4">
						<RequestTable tab={tab} tabs={tabs} />
					</div>
				</div>
			</MainContainer>
			{modal === "tool" && (
				<AddUsersModal
					handleClose={toggleUploadModal}
					title={"Upload new tool"}
					subtitle="Add new tool"
					handleImport={async pres2 => {
						await onSubmit(pres2);
					}}
					sample={RawSample}
					loading={loading}
				/>
			)}
			{modal === "done" && (
				<DoneModal
					page={"Tool"}
					handleClose={() => setModal("")}
					close={() => setModal("")}
					path={"/tools"}
				/>
			)}
		</div>
	);
};

export default NewRequest;
